var _title, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYourScans = function SvgYourScans(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "117px",
    viewBox: "0 0 140 117",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Your scans")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.102,0.15 C14.55,0.35 14.256,0.978 14.492,1.623 L14.492,1.623 L17.004,8.525 C18.177,11.746 16.537,15.26 13.316,16.433 L13.316,16.433 C10.096,17.605 6.58,15.967 5.408,12.745 L5.408,12.745 L2.896,5.844 C2.661,5.199 1.941,4.94 1.389,5.141 L1.389,5.141 C0.837,5.342 0.453,6.003 0.687,6.647 L0.687,6.647 L3.199,13.55 C4.773,17.875 9.669,20.157 14.086,18.55 L14.086,18.55 C18.412,16.975 20.695,12.08 19.12,7.755 L19.12,7.755 L16.608,0.852 C16.428,0.357 16.016,0.07 15.542,0.07 L15.542,0.07 C15.4,0.07 15.251,0.096 15.102,0.15 L15.102,0.15 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.415,0.484 C14.864,0.686 14.48,1.346 14.805,1.956 L14.805,1.956 L17.317,8.859 C18.49,12.08 16.851,15.594 13.63,16.768 L13.63,16.768 C10.409,17.94 6.894,16.301 5.722,13.08 L5.722,13.08 L3.21,6.178 C2.976,5.533 2.348,5.242 1.703,5.475 L1.703,5.475 C1.06,5.71 0.766,6.337 1.001,6.981 L1.001,6.981 L3.479,13.792 C5.088,18.209 9.983,20.492 14.4,18.884 L14.4,18.884 C18.726,17.31 21.008,12.414 19.434,8.089 L19.434,8.089 L16.921,1.186 C16.741,0.691 16.329,0.404 15.855,0.404 L15.855,0.404 C15.712,0.404 15.564,0.43 15.415,0.484 L15.415,0.484 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.112,1.126 C1.695,2.734 -0.588,7.63 1.02,12.047 L1.02,12.047 L3.532,18.949 C3.766,19.594 4.394,19.885 5.038,19.651 L5.038,19.651 C5.682,19.417 5.975,18.79 5.741,18.145 L5.741,18.145 L3.229,11.243 C2.056,8.022 3.695,4.508 6.916,3.335 L6.916,3.335 C10.137,2.163 13.652,3.801 14.824,7.022 L14.824,7.022 L17.337,13.924 C17.571,14.569 18.199,14.861 18.843,14.626 L18.843,14.626 C19.487,14.393 19.78,13.765 19.546,13.121 L19.546,13.121 L17.033,6.219 C15.774,2.761 12.502,0.611 9.02,0.611 L9.02,0.611 C8.054,0.611 7.072,0.777 6.112,1.126 L6.112,1.126 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89,0.759 C1.474,2.366 -0.81,7.262 0.798,11.679 L0.798,11.679 L3.311,18.581 C3.544,19.226 4.08,19.551 4.724,19.318 L4.724,19.318 C5.369,19.083 5.66,18.455 5.426,17.812 L5.426,17.812 L2.915,10.909 C1.742,7.688 3.382,4.172 6.602,3.001 L6.602,3.001 C9.823,1.828 13.337,3.468 14.51,6.689 L14.51,6.689 L17.022,13.591 C17.257,14.234 17.884,14.527 18.529,14.293 L18.529,14.293 C19.172,14.059 19.465,13.431 19.323,12.753 L19.323,12.753 L16.811,5.851 C15.553,2.393 12.28,0.243 8.799,0.243 L8.799,0.243 C7.832,0.243 6.85,0.409 5.89,0.759 L5.89,0.759 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.782,1.186 L1.269,8.089 C-0.305,12.414 1.979,17.31 6.395,18.918 L6.395,18.918 C10.72,20.492 15.616,18.209 17.19,13.883 L17.19,13.883 L19.703,6.981 C19.937,6.337 19.644,5.71 19,5.475 L19,5.475 C18.448,5.274 17.821,5.567 17.585,6.211 L17.585,6.211 L15.074,13.113 C13.901,16.334 10.386,17.974 7.165,16.8 L7.165,16.8 C3.945,15.628 2.305,12.114 3.478,8.893 L3.478,8.893 L5.99,1.99 C6.224,1.346 5.84,0.686 5.288,0.484 L5.288,0.484 C5.165,0.439 5.034,0.418 4.902,0.418 L4.902,0.418 C4.44,0.418 3.964,0.686 3.782,1.186 L3.782,1.186 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.095,0.852 L0.617,7.663 C-0.991,12.08 1.292,16.975 5.71,18.583 L5.71,18.583 C10.034,20.157 14.93,17.875 16.505,13.55 L16.505,13.55 L19.016,6.647 C19.25,6.003 18.959,5.375 18.314,5.141 L18.314,5.141 C17.763,4.94 17.043,5.199 16.9,5.877 L16.9,5.877 L14.388,12.779 C13.216,15.999 9.701,17.638 6.479,16.466 L6.479,16.466 C3.258,15.294 1.619,11.779 2.792,8.558 L2.792,8.558 L5.304,1.656 C5.539,1.012 5.245,0.384 4.602,0.15 L4.602,0.15 C4.453,0.096 4.304,0.07 4.162,0.07 L4.162,0.07 C3.688,0.07 3.275,0.357 3.095,0.852 L3.095,0.852 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.892,5.851 L0.38,12.753 C0.146,13.397 0.439,14.025 1.083,14.26 L1.083,14.26 C1.727,14.494 2.354,14.201 2.59,13.557 L2.59,13.557 L5.102,6.655 C6.274,3.433 9.789,1.794 13.01,2.966 L13.01,2.966 C16.23,4.14 17.87,7.654 16.697,10.875 L16.697,10.875 L14.185,17.778 C13.95,18.422 14.243,19.049 14.887,19.284 L14.887,19.284 C15.531,19.518 16.159,19.226 16.393,18.581 L16.393,18.581 L18.906,11.679 C20.513,7.262 18.231,2.366 13.814,0.759 L13.814,0.759 C12.853,0.409 11.871,0.243 10.905,0.243 L10.905,0.243 C7.424,0.244 4.151,2.394 2.892,5.851 L2.892,5.851 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.671,6.219 L0.159,13.121 C-0.076,13.765 0.124,14.359 0.769,14.593 L0.769,14.593 C1.412,14.828 2.041,14.535 2.275,13.891 L2.275,13.891 L4.787,6.989 C5.959,3.768 9.475,2.129 12.695,3.302 L12.695,3.302 C15.917,4.474 17.556,7.988 16.384,11.21 L16.384,11.21 L13.871,18.112 C13.636,18.756 13.93,19.384 14.573,19.618 L14.573,19.618 C15.217,19.853 15.846,19.559 16.172,18.949 L16.172,18.949 L18.684,12.047 C20.292,7.63 18.008,2.734 13.591,1.126 L13.591,1.126 C12.631,0.776 11.649,0.611 10.683,0.611 L10.683,0.611 C7.202,0.611 3.929,2.761 2.671,6.219 L2.671,6.219 Z",
    id: "path-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Your-scans",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(1.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "-0.0001 29.6822 29.6819 111.2322 111.2319 81.5502 81.5509 0.0002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "-0.0003 29.682 81.5507 0 111.2317 81.55 29.6827 111.232"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(82.000000, 59.232000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "9.4616 0.8622 14.8256 15.6002 0.0876 20.9652"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    stroke: "#37D5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "9.4616 0.8622 14.8256 15.6002 0.0876 20.9652"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(60.000000, 14.232000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-7",
    fill: "#FFFFFF",
    points: "0.0944 5.5389 14.8324 0.1749 20.1974 14.9129"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8",
    stroke: "#37D5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.0944 5.5389 14.8324 0.1749 20.1974 14.9129"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(14.000000, 30.232000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-10",
    fill: "#FFFFFF",
    points: "5.7712 20.9061 0.4072 6.1681 15.1442 0.8031"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-11",
    stroke: "#37D5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "5.7712 20.9061 0.4072 6.1681 15.1442 0.8031"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(31.000000, 81.232000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-13",
    fill: "#FFFFFF",
    points: "20.1374 10.2293 5.4004 15.5933 0.0354 0.8553"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-14",
    stroke: "#37D5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "20.1374 10.2293 5.4004 15.5933 0.0354 0.8553"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(32.000000, 39.232000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#201574",
    mask: "url(#mask-2)",
    points: "-5.9915 2.616 19.1325 -6.529 28.2775 18.596 3.1535 27.74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(50.000000, 32.232000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#201574",
    mask: "url(#mask-4)",
    points: "-5.6771 2.95 19.4469 -6.195 28.5919 18.93 3.4679 28.074"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(59.000000, 52.232000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#201574",
    mask: "url(#mask-6)",
    points: "-8.1702 1.1141 17.0458 -8.0649 26.2238 17.1521 1.0078 26.3301"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(41.000000, 59.232000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#201574",
    mask: "url(#mask-8)",
    points: "-8.3929 0.7459 16.8241 -8.4321 26.0021 16.7839 0.7861 25.9619"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#FFFFFF",
    points: "56.153 0.0004 137.704 29.6824 108.022 111.2314 26.471 81.5504"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-29",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "56.153 0.0004 137.704 29.6824 108.022 111.2314 26.471 81.5504"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(86.000000, 81.232000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-31",
    fill: "#FFFFFF",
    points: "20.6676 0.8553 15.3036 15.5933 0.5656 10.2293"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-32",
    stroke: "#37D5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "20.6676 0.8553 15.3036 15.5933 0.5656 10.2293"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(108.000000, 30.232000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-34",
    fill: "#FFFFFF",
    points: "0.5592 0.8035 15.2962 6.1675 9.9332 20.9065"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-35",
    stroke: "#37D5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.5592 0.8035 15.2962 6.1675 9.9332 20.9065"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(57.000000, 14.232000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-37",
    fill: "#FFFFFF",
    points: "0.5075 14.9129 5.8705 0.1749 20.6095 5.5389"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-38",
    stroke: "#37D5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.5075 14.9129 5.8705 0.1749 20.6095 5.5389"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(40.000000, 59.232000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-40",
    fill: "#FFFFFF",
    points: "15.6159 20.9647 0.8779 15.6007 6.2419 0.8617"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-41",
    stroke: "#37D5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "15.6159 20.9647 0.8779 15.6007 6.2419 0.8617"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(67.000000, 32.232000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#201574",
    mask: "url(#mask-10)",
    points: "1.2565 -6.1945 26.3805 2.9505 17.2365 28.0745 -7.8885 18.9295"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(86.000000, 39.232000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#201574",
    mask: "url(#mask-12)",
    points: "0.571 -6.5285 25.695 2.6165 16.55 27.7405 -8.574 18.5955"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    transform: "translate(77.000000, 59.232000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-50"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#201574",
    mask: "url(#mask-14)",
    points: "2.8796 -8.4318 28.0966 0.7462 18.9186 25.9622 -6.2984 16.7842"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(59.000000, 52.232000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#201574",
    mask: "url(#mask-16)",
    points: "2.6579 -8.0646 27.8749 1.1144 18.6959 26.3304 -6.5201 17.1524"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYourScans, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yourScans.1561a56e.svg";
export { ForwardRef as ReactComponent };